import './css/Cartiglio.css'

const Cartiglio = (props) => {
  return (
      <div 
        className='model-cartiglio bg-leggera'
      >
        <h1 className='text-enhanced'>{props.config.lift.model.modelname}</h1>
        <label>platform dimensions</label>
        <h4 className='text-enhanced'>{props.config.lift.model.dimensions.depth} x {props.config.lift.model.dimensions.width} cm</h4>
        <label>max capacity</label>
        <h5 className='text-enhanced'>{props.config.lift.model.capacity} Kg</h5>
      </div>
  )
}
export default Cartiglio